<app-homepage-header pageName="Privacy Policy"></app-homepage-header>

<section class="section-wrapper privacy-policy-section-wrapper mt-120px">
  <div class="container flex-direction-column">
    <span class="privacy-policy-title">{{'privacy_policy_content.privacy_policy' | translate}}</span>

    <div class="mt-70px">
      <span class="privacy-policy-tertiary-title">ScanMe.am</span>
      <span class="privacy-policy-text">
        {{'privacy_policy_content.privacy_policy_text' | translate}}
        <a class="privacy-policy-text link" target="_blank" href="https://scanme.am">www.scanme.am</a>
        {{'privacy_policy_content.privacy_policy_text_1' | translate}}
        <br>
        <br>
        {{'privacy_policy_content.privacy_policy_text_2' | translate}}
      </span>
    </div>

    @for (part of secondaryParts[0]; track part) {
      <div class="mt-60px flex-direction-column">
        <span class="privacy-policy-secondary-title">{{ part.title | translate }}</span>
        <span class="privacy-policy-text mt-10px">{{ part.description | translate }}</span>

        @for (privacyPrinciple of privacyPrinciples; track privacyPrinciple) {
          <div [class]='privacyPrinciple.class'>
            <span class='privacy-policy-tertiary-title'>{{ privacyPrinciple.title | translate }}</span>
            <span class='privacy-policy-text'>{{ privacyPrinciple.description | translate }}</span>
          </div>
        }
      </div>
    }

    @for (part of secondaryParts[1]; track part) {
      <div class="mt-60px flex-direction-column">
        <span class="privacy-policy-secondary-title">{{ part.title | translate }}</span>

        <span class="privacy-policy-text mt-10px">
          {{ part.description | translate }}

          @if (part.additionalDescription) {
            <br><br>
            {{ part.additionalDescription | translate }}
          }
        </span>
      </div>
    }

    <div class="mt-60px flex-direction-column">
      <span class="privacy-policy-secondary-title">{{'privacy_policy_content.personal_information' | translate}}</span>

      <div class="privacy-policy-text flex-direction-column mt-10px">
        <span>{{'privacy_policy_content.personal_information_text' | translate}}</span>
        <br>
        <span>•	{{'privacy_policy_content.personal_details' | translate}}</span>
        <span>•	{{'privacy_policy_content.contact' | translate}}</span>
        <span>•	{{'privacy_policy_content.account_details' | translate}}</span>
        <span>•	{{'privacy_policy_content.payment_information' | translate}}</span>
        <span>•	{{'privacy_policy_content.geolocation' | translate}}</span>
        <span>•	{{'privacy_policy_content.text' | translate}}</span>
      </div>
    </div>

    <div class="mt-60px flex-direction-column">
      <span class="privacy-policy-secondary-title">{{'privacy_policy_content.collected_information' | translate}}</span>

      <div class="privacy-policy-text flex-direction-column mt-10px">
        <span>{{'privacy_policy_content.collected_information_text' | translate}}</span>
        <br>
        <span>•	{{'privacy_policy_content.create_user_accounts' | translate}}</span>
        <span>•	{{'privacy_policy_content.deliver_products' | translate}}</span>
        <span>•	{{'privacy_policy_content.description_1' | translate}}</span>
        <span>•	{{'privacy_policy_content.description_2' | translate}}</span>
        <span>•	{{'privacy_policy_content.description_3' | translate}}</span>
        <span>•	{{'privacy_policy_content.description_4' | translate}}</span>
        <span>•	{{'privacy_policy_content.description_5' | translate}}</span>
        <span>•	{{'privacy_policy_content.description_6' | translate}}</span>
        <span>•	{{'privacy_policy_content.description_7' | translate}}</span>
        <span>•	{{'privacy_policy_content.description_8' | translate}}</span>
        <span>•	{{'privacy_policy_content.description_9' | translate}}</span>
      </div>
    </div>

    @for (part of secondaryParts[2]; track part) {
      <div class="mt-60px flex-direction-column">
        <span class="privacy-policy-secondary-title"> {{ part.title | translate}} </span>
        <span class="privacy-policy-text mt-10px"> {{ part.description | translate }} </span>
      </div>
    }
  </div>
</section>


<div class="mt-70px">
  <app-footer></app-footer>
</div>
